/* eslint-disable no-restricted-globals */
/* eslint-disable unicorn/no-useless-undefined */
import { Box, Button, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Add, Delete, Edit } from "@mui/icons-material";
import useViewModel from "./ViewModel";
import { useNavigate } from "react-router-dom";
import { FormState, UserInterfaceState } from "../../../../shared/Enum";
import { useSelector } from "react-redux";
import { selectProfile } from "../../../../store/profile/selector";
import ConfirmationDialog from "../../../../shared/Components/ConfirmationDialog";
import LoadingBackdrop from "../../../../shared/Components/LoadingBackdrop";
import PageContentHeader from "../../../../shared/Components/PageContentHeader";
import { enqueueSnackbar } from "notistack";

export function MasterLocationPage() {
  const { data, method } = useViewModel();
  const navigate = useNavigate();
  const profile = useSelector(selectProfile);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [idToDelete, setIdToDelete] = useState("");

  useEffect(() => {
    method.onGetLocationList();
  }, []);

  useEffect(() => {
    if (
      UserInterfaceState.isError(data.uiState) ||
      FormState.isError(data.formState)
    ) {
      enqueueSnackbar({
        message:
          "Oops, something went wrong. Please try again later. If the issue persists, try refreshing the page or restarting the app.",
        variant: "error",
      });
    }
  }, [data.uiState, data.formState]);

  const columns: GridColDef[] = [
    {
      field: "locationId",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">ID</Typography>
      ),
      renderCell: (e) => (
        <Typography className="p-3">{e.row.locationId}</Typography>
      ),
      width: 400,
    },
    {
      field: "locationName",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Name</Typography>
      ),
      renderCell: (e) => (
        <Typography className="p-3 truncate">{e.row.locationName}</Typography>
      ),
      width: 750,
    },
    {
      field: "action",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Action</Typography>
      ),
      renderCell: (e) => (
        <Box className="flex gap-2">
          <Button
            variant="contained"
            className="mt-1"
            onClick={() => navigate(`/master-location/${e.row.locationId}`)}
          >
            <Edit />
          </Button>
          <Button
            variant="outlined"
            className="mt-1"
            onClick={() => {
              setIdToDelete(e.row.locationId);
              setDeleteDialog(true);
            }}
          >
            <Delete />
          </Button>
        </Box>
      ),
      width: 200,
    },
  ];

  return (
    <Box className="flex flex-col w-full p-5">
      <PageContentHeader label="List of Locations" />
      <ConfirmationDialog
        open={deleteDialog}
        description="Are you sure you want to delete this location?"
        onCancel={() => setDeleteDialog(false)}
        onClose={() => setDeleteDialog(false)}
        onSubmit={() => {
          method.onDeleteLocation({
            binusianId: profile.binusianId,
            locationId: idToDelete,
          });
          setDeleteDialog(false);
        }}
      />
      <Box className="flex justify-end p-3 w-full">
        <Button
          variant="contained"
          className="flex h-min"
          onClick={() => {
            navigate("/master-location/create");
          }}
        >
          <Add />
          Add New
        </Button>
      </Box>
      <div className="bg-white m-3 border border-gray-400">
        <DataGrid
          rows={data.locationList}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          getRowId={(row) => row.locationId}
          pageSizeOptions={[5, 10]}
          autoHeight
          getRowHeight={() => "auto"}
        />
      </div>
      <LoadingBackdrop
        isOpen={
          UserInterfaceState.isLoading(data.uiState) ||
          FormState.isLoading(data.formState)
        }
      />
    </Box>
  );
}
